<div class="main">
    <div class="left" [ngClass]="isAtLeastMedium ? 'flex-basis-45' : 'flex-basis-100'">
        <div class="body">
            <router-outlet></router-outlet>
        </div>

        <div class="footer">
            <div>© Energies Demain</div>
            <div class="contact"><i class="icon-mail-01"></i>contact&#64;sde82.fr</div>
        </div>
    </div>

    <div class="right" [ngClass]="isAtLeastMedium ? 'd-flex' : 'd-none'">
        <div class="slogan-container">
            <div class="logo">
                <img src="../../../assets/img/logo_sde82_high.png" alt="logo" width="230" />
            </div>
            <div class="slogan-text">
                Simulateur de tracé de <br> Réseau de Chaleur Urbain
            </div>
        </div>
        <div class="image-container">
            <div class="image"></div>
        </div>
    </div>
</div>
